/**
 * PROTOTYPE CONTENT — NOT VERIFIED.
 *
 * Restored verbatim from the design prototype in `design-reference/`. The values
 * below were written to demonstrate the layout, not from source documents: the
 * registration number, VAT number, addresses, telephone numbers, registration
 * date and gradings are all invented, and the February 2026 date contradicts the
 * actual CIPC registration date of 8 August 2026.
 *
 * Every one of these must be confirmed against the CIPC / SARS / CIDB documents
 * or removed before the site is published. See CONTENT-STATUS.md.
 */

export const company = {
  name: 'Samloryx Engineering',
  legalName: 'Samloryx Engineering (Pty) Ltd',
  registrationNumber: '2026/418772/07',
  vatNumber: '4290187336',
  registeredOn: 'February 2026',
  /** Cities strip in the hero title block. */
  locations: 'Burgersfort · Limpopo',
  /** Sheet marker in the hero title block. */
  sheetRef: 'Sheet 01 / Rev A / 2026',
  /** Standing paragraph under the footer logo. */
  footerBlurb:
    'Samloryx Engineering (Pty) Ltd — civil and mining infrastructure contractors. Registered February 2026. CIDB 6CE / 6GB PE. B-BBEE Level 1 (EME).',
  /** Confirmed by Samuel — the one address on this site that is real. */
  address: 'Tubase Township, Burgersfort, Limpopo',
  phone: '+27 11 468 2200',
  email: 'info@samloryx.co.za',
  officeHours: [
    'Monday–Thursday · 07:00–17:00',
    'Friday · 07:00–14:00',
    'Site emergencies · 24 hours, 083 402 1188',
  ],
}

/** Eyebrow above the home-page headline. */
export const heroEyebrow = 'CIDB 6CE / 6GB PE · B-BBEE Level 1 · Registered February 2026'

/** The four figures under the home-page hero. */
export interface HeroFact {
  value: string
  label: string
}

export const heroFacts: HeroFact[] = [
  { value: 'Feb 2026', label: 'Based in Burgersfort' },
  { value: 'R48 m', label: 'Order book' },
  { value: '6 CE / 6 GB', label: 'CIDB grading, PE' },
  { value: 'Level 1', label: 'B-BBEE contributor' },
]

/**
 * Animated counters on the home page. `target: null` renders a placeholder
 * instead of counting.
 */
export interface CounterDef {
  target: number | null
  prefix: string
  suffix: string
  label: string
}

export const counterDefs: CounterDef[] = [
  { target: 6, prefix: '', suffix: '', label: 'Contracts secured' },
  { target: 41, prefix: '', suffix: '', label: 'People employed' },
  { target: 48, prefix: 'R', suffix: ' m', label: 'Order book, 2026' },
  { target: 46, prefix: '', suffix: ' 000', label: 'Site hours, zero LTIs' },
]

/** Blue strip under the hero. */
export const onSiteTicker: string[] = [
  'Erf 1140 Earthworks · Centurion',
  'Kyalami Ridge Yard · Gauteng',
  'Midvaal Pipeline · Gauteng',
  'Emalahleni Access Road · from Oct',
]

export interface Office {
  tag: string
  city: string
  address: string
  phone: string
  email: string
}

export const offices: Office[] = [
  {
    tag: 'Head office',
    city: 'Burgersfort',
    address: 'Tubase Township, Burgersfort, Limpopo',
    phone: '+27 11 468 2200',
    email: 'info@samloryx.co.za',
  },
]

export const footerOffices: string[] = ['Burgersfort — head office']
